<template>
    <router-view></router-view>
</template>

<script>
export default {
    mounted() {
        this.$store.dispatch('seismicPipes/fetchPipes').then(() => {
            this.$store.dispatch('seismicSystem/calculateWeights');
        });
    }
};
</script>
